import React from 'react';
import ReactQuill, { Quill } from 'react-quill-new';
import 'react-quill-new/dist/quill.snow.css';

function MyComponent({ value, setValue }) {
    return (
        <ReactQuill useSemanticHTML={false}
            placeholder="Write your message.."
            modules={{
                toolbar: [
                    ['bold', 'italic', 'underline'],
                    [{ list: 'ordered' }, { list: 'bullet' }],
                    ['link', 'image', 'imagecustom'],
                ],
            }}
            theme="snow"
            defaultValue={value}
            onChange={setValue}
        />
    );
}
export default MyComponent;
